import {
  calculateProjection,
  getMonthlyProjectionSeries,
  type ProjectionMovement,
} from '@financego/core';

import type { DashboardSnapshot } from './dashboard.types';

export interface CalendarProjectionPoint {
  readonly balance: number | null;
  readonly date: string;
  readonly movements: readonly ProjectionMovement[];
  readonly net: number;
}

export function buildCalendarProjection(
  snapshot: DashboardSnapshot,
  year: number,
  month: number,
): readonly CalendarProjectionPoint[] {
  const monthlySeries = getMonthlyProjectionSeries(snapshot.coreTransactions, year, month, {
    includeTransfers: true,
    validations: snapshot.agenda,
  });
  const today = new Date(`${snapshot.today}T00:00:00.000Z`);
  const monthDistance = (year - today.getUTCFullYear()) * 12 + (month - (today.getUTCMonth() + 1));

  if (monthDistance < 0) {
    return monthlySeries.map((point) => ({ ...point, balance: null }));
  }

  const projection = calculateProjection(snapshot.coreTransactions, {
    monthsAhead: monthDistance + 1,
    today: snapshot.today,
    validations: snapshot.agenda,
  });
  const balances = new Map(
    projection.points.map((point) => [point.date, point.balance + snapshot.currentWalletBalance]),
  );

  return monthlySeries.map((point) => ({
    ...point,
    balance: point.date < snapshot.today ? null : (balances.get(point.date) ?? null),
  }));
}
